import React, { useEffect } from "react";
import { X } from "lucide-react";

/**
 * Modal — fullscreen backdrop with centered glass card.
 * Esc to close. Click backdrop to close.
 */
const Modal = ({ open, onClose, children, testId = "modal", maxWidth = "max-w-2xl" }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      data-testid={testId}
      className="fixed inset-0 z-[100] flex items-center justify-center px-4 py-8 backdrop animate-fade-in"
      onClick={onClose}
    >
      <div
        className={`relative w-full ${maxWidth} animate-modal-in`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative glass-strong rounded-2xl overflow-hidden">
          <button
            data-testid={`${testId}-close`}
            onClick={onClose}
            aria-label="Close"
            className="absolute top-4 right-4 z-10 w-10 h-10 grid place-items-center rounded-full border border-brand-border text-zinc-300 hover:text-white hover:border-brand-purple hover:bg-brand-purple/10 transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
